export type PaymentsButtonPlace = 'onTopLevel' | 'insideShowMore';

export interface AvailablePmsList {
  googlePay: boolean;
  applePay: boolean;
  payPal: string[]; // PaymentMethodSourceName[PayPal, PayPalCredit, PayPalPayLater, PayPalVenmo]
}

/**
 * @summary Enum with source names of payment methods - include fundingSources from Paypal PM, ApplePay && GooglePay PM's
 */
export enum PaymentMethodSourceName {
  ApplePay = 'applePay',
  PayPal = 'paypal',
  PayPalCredit = 'credit',
  PayPalPayLater = 'paylater',
  PayPalVenmo = 'venmo',
  GooglePay = 'googlePay',
}
